export const DEFAULT_EDITOR_TEXT = '// Your code here';
export const DEFAULT_OUTPUT_TEXT = '';
export const DEFAULT_OUTPUT_ERROR = '';

export const EDITOR_THEME = {
    DARK: 'Sunburst',
    LIGHT: 'IDLE',
};

